app.login = (function() {
  var locale = theme.locale;

  // These are the constraints used to validate the form
  var constraints = {
    'customer[email]': {
      presence: {
        message: "^" + locale.validation.required
      },
      email: {
        message: "^" + locale.validation.valid_email
      }
    },
    'customer[password]': {
      presence: {
        message: "^" + locale.validation.required
      }
    }
  };

  /**
   * Documents is ready.
   */
  var ready = function() {
    var form = document.getElementById('customer_login');
    Validator.check(form, constraints);
  };

  $(function() {
    ready();
  });
})();